import { editCadreSaga } from './editCadre'
import { getAllCadresSaga } from './getAllCadres'
import { deleteCadreSaga } from './deleteCadre'
import { addCadreSaga } from './addCadre'

const userSagas = [
    editCadreSaga,
    deleteCadreSaga,
    addCadreSaga,
    getAllCadresSaga,
]

export default userSagas
